export const API_ROUTES = {
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  websites: "/websites",
  addons: "/addons",
  plans: "/plans",
  // Public, unauthenticated — for the logged-out marketing homepage's
  // pricing section. `plans` above requires a token.
  publicPlans: "/public-plans",
  commission: "/commission",
  coupon: "/coupon",
  users: "/users",
  userStatus: "/users/status",
  agents: "/agents",
  setupIntent: "/payment/setup-intent",
  subscriptionsList: "/subscriptions",
  subscription: "/plan-subscription",
  updatePlan: "/update-plan",
  subscriptionDetails: "/subscription-detail",
  cancelSubscription: "/cancel-subscription",
  resumeSubscription: "/resume-subscription",
  attachAddons: "/attach-addon",
  cancelAddon: "/cancel-addon",
  paymentMethod: "/payment/update-default-method",
  invoices: "/invoices",
  publishArticle: "/publish-articles",
  publishArticleSuggestTitles: "/publish-articles/suggest-titles",
  runWorkflowsNow: "/admin/workflows/run-now",
  aiUsageSummary: "/admin/ai-usage/summary",
  adminChangelog: "/admin/changelog",
  adminProspecting: "/admin/prospecting",
  adminSiteStats: "/admin/site-stats",
  aiUsageSerperSummary: "/admin/ai-usage/serper-summary",
  aiUsageProspectingSummary: "/admin/ai-usage/prospecting-summary",
  aiUsageByArticle: "/admin/ai-usage/by-article",
  aiUsageLogs: "/admin/ai-usage/logs",
  aiUsageResearchPackWebsites: "/admin/ai-usage/research-pack-websites",
  publishBulkArticle: "/publish-articles/bulk-store",
  publishArticleStatus: "/publish-articles/change-status",
  publishArticleDelete: "/publish-articles/delete",
  articleAudit: "/publish-articles", // used as `${articleAudit}/{id}/audit`
  technicalSeoAudit: "/websites", // used as `${technicalSeoAudit}/{websiteId}/technical-seo-audit`
  getCommissionList: "/agent-commission",
  commissionStatus: "/commission/change-status",
  changePassword: "/change-password",
  updateProfile: "/update-profile",
  dashboard: "/dashboard/stats",
  dashboardOverview: "/dashboard/overview",
  webState: "/websites/stats",
  googleAuth: "/google/auth/url",
  googleAnalytics: "/google/analytics/accounts",
  googleSites: "/google/search-console/sites",
  googleSync: "/google/sync",
  keywordAutomation: "/keyword-automation",
  generateKeywordAutomation: "/keyword-automation/generate",
  detectNicheKeywordAutomation: "/keyword-automation/detect-niche",
  suggestSeedKeywords: "/keyword-automation/suggest-seed-keywords",
  latestResultsKeywordAutomation: "/keyword-automation/latest-results",
  startOverKeywordAutomation: "/keyword-automation/start-over",
};